import * as React from 'react';
import Loader from './Loader';

export const withLoader =
    <T extends Record<string, unknown>>(Component: React.ComponentType<React.PropsWithChildren<T>>) =>
    ({ isLoading, ...props }: T & { isLoading: boolean; customLoader?: React.ReactNode }) => {
        const loader = props.customLoader ?? <Loader />;
        return <>{isLoading ? loader : <Component {...(props as T)} />}</>;
    };
